import React, { FC, ReactElement } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { localizeType } from '../../commonType';
import { resetSoldPackage } from '../../features/offerSearch/offerSearchSlice';
import { SoldPackageInformation } from '../../features/offerSearch/types';
import { fullDateFormat } from '../../util/date';
import withLocalization from '../hoc/withLocalization';
import './ProspectInformation.scss';

interface SoldPackageInformationType {
  packageInformation: SoldPackageInformation;
  localize: localizeType;
}
const SoldPackageInformationDetails: FC<SoldPackageInformationType> = (
  props: SoldPackageInformationType,
): ReactElement => {
  const { localize, packageInformation } = props;
  const dispatch = useDispatch();
  const handleBackToSearch = () => {
    dispatch(resetSoldPackage());
  };
  let fullAddress: string | undefined = undefined;
  fullAddress = packageInformation.address ? packageInformation.address : '';
  fullAddress = packageInformation.city ? `${fullAddress}, ${packageInformation.city}` : fullAddress;
  fullAddress = packageInformation.state ? `${fullAddress}, ${packageInformation.state}` : fullAddress;
  fullAddress = packageInformation.zip ? `${fullAddress}, ${packageInformation.zip}` : fullAddress;
  return (
    <div className="upperCase">
      <br />
      <h5 className="card-title sub-title">
        {localize('preview-sales-engine.static-content.copy.Labels.labels#package-already-sold')}
      </h5>
      <hr />

      <div className="row">
        {!packageInformation.has3AError && (
          <div className="col-sm-9 ">
            <table>
              <tbody>
                {packageInformation.loc ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize('preview-sales-engine.static-content.copy.package-summary-component.loc-label')}
                      </strong>
                    </td>
                    <td>{packageInformation.loc}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.locDescription ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize(
                          'preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-loc-description',
                        )}
                      </strong>
                    </td>
                    <td>{packageInformation.locDescription}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.leadId ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize(
                          'preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-lead-id',
                        )}
                      </strong>
                    </td>
                    <td>{packageInformation.leadId}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.lastName ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize('preview-sales-engine.static-content.copy.Confirmation Page.last-name')}
                      </strong>
                    </td>
                    <td>{packageInformation.lastName}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.firstName ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize('preview-sales-engine.static-content.copy.contact-information-page.first-name')}:
                      </strong>
                    </td>
                    <td>{packageInformation.firstName}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {fullAddress ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize('preview-sales-engine.static-content.copy.associate-search-page.address-label')}:
                      </strong>
                    </td>
                    <td>{fullAddress}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.arrivalDate ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize(
                          'preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-arrival-date',
                        )}
                      </strong>
                    </td>
                    <td>{fullDateFormat(packageInformation.arrivalDate)}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.departureDate ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize(
                          'preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-departure-date',
                        )}
                      </strong>
                    </td>
                    <td>{fullDateFormat(packageInformation.departureDate)}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.destination ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize(
                          'preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-destination',
                        )}
                      </strong>
                    </td>
                    <td>{packageInformation.destination}</td>
                  </tr>
                ) : (
                  <></>
                )}
                {packageInformation.totalAmount ? (
                  <tr>
                    <td className="soldPackage">
                      <strong>
                        {localize(
                          'preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-total-amount',
                        )}
                      </strong>
                    </td>
                    <td>{packageInformation.totalAmount}</td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </div>
        )}
        {packageInformation.has3AError ? (
          <div className="col-sm-9">
            <table>
              <tbody>
                <tr>
                  <td>{packageInformation.soldPackageStatusDescription}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <></>
        )}
        <div className="col-sm-3 alignCenter">
          <Button onClick={handleBackToSearch}>
            {localize('preview-sales-engine.static-content.copy.Labels.labels#package-already-sold-button-text')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(withLocalization(SoldPackageInformationDetails));
